import * as React from 'react';
import NumberFormat from 'react-number-format';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import { FileList } from 'src/components/shared/Files/FileList';
import { DateInput } from 'src/components/shared/Input/DateInput';
// import { appliedRate } from 'src/config';
import { IFile, IProject, IProposition, IStep } from 'src/model';
import {
  createSteps,
  deleteSteps,
  sendProposition,
  updateProposition,
} from 'src/services';
import { ProjectPropositionCardWithGlobalContext } from '../ProjectPropositions/ProjectPropositionCard/ProjectPropositionCard';
import { PropositionStepListEdition } from './PropositionStepListEdition/PropositionStepListEdition';

interface IPropositionEditionProps {
  project: IProject;
  proposition: IProposition;
  handlePropositionChange: (proposition: IProposition) => void;
}



export const PropositionEdition: React.SFC<IPropositionEditionProps> = ({
  handlePropositionChange,
  project,
  proposition,
}) => {
  const [state, setState] = React.useState({
    edit: false,
    invalid: false,
    proposition: {
      ...proposition,
    //  appliedRate,
    },
  });
  const isValid =
    !!state.proposition.title &&
    !!state.proposition.description &&
    (state.proposition.price || state.proposition.dailyPrice);

  const applyRate = (price: number) =>
  Math.round(price * ((state.proposition.appliedRate + 100) / 100));

  const toggleEdit = () => {
    setState({
      edit: !state.edit,
      invalid: false,
      proposition: {
        ...proposition,
     //   appliedRate,
      },
    });
  };

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      invalid: false,
      proposition: {
        ...state.proposition,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };

  const handleDateChange = (date: Date) => {
    setState({
      ...state,
      proposition: {
        ...state.proposition,
        startingDate: date,
      },
    });
  };

  const handleEstimatedDateChange = (date: Date) => {
    setState({
      ...state,
      proposition: {
        ...state.proposition,
        estimatedEndDate: date,
      },
    });
  };

  const handleStepListChange = (stepList: IStep[]) => {
    setState({
      ...state,
      proposition: {
        ...state.proposition,
        stepList,
      },
    });
  };

  const deleteStep = (stepNumber: number) => {
    const stepList = state.proposition.stepList
      .filter((step: IStep) => step.stepNumber !== stepNumber)
      .map((step: IStep, i: number) => ({ ...step, stepNumber: i + 1 }));

    const newProposition = state.proposition;
    newProposition.stepList = stepList;

    setState({
      ...state,
      proposition: newProposition,
    });
  };

  const handleFilesUpdate = (files: IFile[]) => {
    setState({
      ...state,
      proposition: { ...state.proposition, files },
    });
  };

  const handleSave = async () => {
    const updatePropositionDto = {
      ...state.proposition,
      finalDailyPrice: applyRate(state.proposition.dailyPrice),
      finalPrice: applyRate(state.proposition.price),
    };
    const propositionId = proposition && proposition._id;
    const stepList = state.proposition.stepList;

    if (stepList.length) {
      const propositionWithoutSteps = await deleteSteps(propositionId);
      if (propositionWithoutSteps) {
        const newStepList = await createSteps(propositionId, stepList);
        if (newStepList) {
          delete (updatePropositionDto as any).stepList;
        }
      }
    } else {
      const propositionWithoutSteps = await deleteSteps(propositionId);
      if (propositionWithoutSteps) {
        delete (updatePropositionDto as any).stepList;
      }
    }

    const updatedProposition = await updateProposition(
      propositionId,
      updatePropositionDto
    );
    if (updatedProposition) {
      setState({
        edit: false,
        invalid: false,
        proposition: {
          ...updatedProposition,
          stepList,
        },
      });
      handlePropositionChange(updatedProposition);
    }
  };

  const handleSend = async () => {
    if (isValid) {
      const updatedProposition = await sendProposition(state.proposition._id);
      if (updatedProposition) {
        setState({
          edit: false,
          invalid: false,
          proposition: updatedProposition,
        });
        handlePropositionChange(updatedProposition);
      }
    } else {
      setState({ ...state, invalid: true });
    }
  };

  return state.proposition.meta.status === 'initial' ? (
    <Form className='p-5'>
      <Row>
        <Col md='12'>
          <FormGroup>
            <span className='text-dark' style={{ fontSize: '32px' }}>
              {project.title}
            </span>
          </FormGroup>
        </Col>
      </Row>
      <Row className='d-flex justify-content-between mt-2'>
        <Col md='5' xs='auto'>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>Titre</span>
            <Input
              type='text'
              name='title'
              placeholder='Titre de la proposition'
              disabled={!state.edit}
              invalid={state.invalid && !!!state.proposition.title}
              value={state.proposition.title ? state.proposition.title : ''}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <span className='d-block font-weight-bolder mb-2'>Proposition</span>
            <Input
              type='textarea'
              name='description'
              placeholder='Description de la proposition'
              disabled={!state.edit}
              invalid={state.invalid && !!!state.proposition.description}
              value={
                state.proposition.description
                  ? state.proposition.description
                  : ''
              }
              onChange={handleChange}
              style={{ minHeight: '190px' }}
            />
          </FormGroup>
          <Row className='d-flex justify-content-between'>
            <Col md='6' xs='auto'>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Budget global
                </span>
                <Input
                  type='text'
                  name='price'
                  placeholder='€'
                  disabled={!state.edit}
                  invalid={state.invalid && !!!state.proposition.price}
                  value={state.proposition.price ? state.proposition.price : ''}
                  onChange={handleChange}
                  tag={NumberFormat}
                  thousandSeparator={' '}
                />
              </FormGroup>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Budget global final
                </span>
                <Input
                  type='text'
                  name='finalPrice'
                  placeholder='€'
                  disabled={true}
                  invalid={state.invalid && !!!state.proposition.price}
                  value={
                    state.proposition.price
                      ? applyRate(state.proposition.price)
                      : ''
                  }
                  tag={NumberFormat}
                  thousandSeparator={' '}
                />
              </FormGroup>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Date de démarrage
                  <br />
                  estimée
                </span>
                <DateInput
                  edit={state.edit}
                  name='startingDate'
                  handleDateChange={handleDateChange}
                  value={
                    state.proposition.startingDate
                      ? new Date(state.proposition.startingDate)
                      : new Date()
                  }
                  dateFormat='dd/MM/yyyy'
                />
              </FormGroup>
            </Col>
            <Col md='6' xs='auto'>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Tarif jour
                </span>
                <Input
                  type='text'
                  name='dailyPrice'
                  placeholder='€'
                  disabled={!state.edit}
                  invalid={state.invalid && !!!state.proposition.dailyPrice}
                  value={
                    state.proposition.dailyPrice
                      ? state.proposition.dailyPrice
                      : ''
                  }
                  onChange={handleChange}
                  tag={NumberFormat}
                  thousandSeparator={' '}
                />
              </FormGroup>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Tarif jour final
                </span>
                <Input
                  type='text'
                  name='finalDailyPrice'
                  placeholder='€'
                  disabled={true}
                  invalid={state.invalid && !!!state.proposition.dailyPrice}
                  value={
                    state.proposition.dailyPrice
                      ? applyRate(state.proposition.dailyPrice)
                      : ''
                  }
                  tag={NumberFormat}
                  thousandSeparator={' '}
                />
              </FormGroup>
              <FormGroup>
                <span className='d-block font-weight-bolder mb-2'>
                  Date de clôture
                  <br />
                  estimée
                </span>
                <DateInput
                  edit={state.edit}
                  name='estimatedEndDate'
                  handleDateChange={handleEstimatedDateChange}
                  value={
                    state.proposition.estimatedEndDate
                      ? new Date(state.proposition.estimatedEndDate)
                      : new Date()
                  }
                  dateFormat='dd/MM/yyyy'
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <FileList
              edit={state.edit}
              files={proposition.files}
              handleFilesUpdate={handleFilesUpdate}
              id={proposition._id}
              type='proposition'
            />
          </FormGroup>
        </Col>
        <Col md='6' xs='auto'>
          <PropositionStepListEdition
            edit={state.edit}
            stepList={state.proposition.stepList}
            handleStepListChange={handleStepListChange}
            deleteStep={deleteStep}
          />
        </Col>
      </Row>
      {!state.edit ? (
        <Row className='d-flex justify-content-between mt-4'>
          <Col md='2'>
            <Button
              className='text-uppercase text-white bg-success border-0'
              onClick={toggleEdit}
            >
              Éditer
            </Button>
          </Col>
          <Col md='4'>
            <Button
              className='text-uppercase text-white bg-secondary border-0 float-right'
              onClick={handleSend}
            >
              Soumettre proposition
            </Button>
          </Col>
        </Row>
      ) : (
        <Row className='d-flex justify-content-between mt-4'>
          <Col md='2'>
            <Button
              className='text-uppercase text-white bg-dark border-0'
              onClick={toggleEdit}
            >
              Annuler
            </Button>
          </Col>
          <Col md='6'>
            <Button
              className='text-uppercase text-white bg-warning border-0 float-right'
              onClick={handleSave}
            >
              Sauvegarder
            </Button>
          </Col>
        </Row>
      )}
    </Form>
  ) : (
    <Row className='p-5'>
      <Col xs='12'>
        <span className='text-dark' style={{ fontSize: '32px' }}>
          {project.title}
        </span>
        <Row className='mt-5'>
          <Col xs='12'>
            <ProjectPropositionCardWithGlobalContext
              proposition={state.proposition}
            />
          </Col>
        </Row>
        {state.proposition.sendingDate && (
          <span className='text-success' style={{ fontSize: '20px' }}>
            {`Merci ! Votre proposition a bien été envoyée le ${new Date(
              state.proposition.sendingDate
            ).toLocaleDateString()}`}
          </span>
        )}
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project/PropositionEdition/PropositionEdition.tsx